import { useQuery, useQueries } from "@tanstack/react-query";

import service, {
  getQualifications,
  getOccupations,
  getEmploymentSectors
  
} from "../../../services/commonLookupService";
import { recordError } from "../../../utils/logService";

export const useLookups = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ["professionalExp"],
        queryFn: () => getQualifications(),
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["occupations"],
        queryFn: () => getOccupations(),
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["employment"],
        queryFn: () => getEmploymentSectors(),
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["particpant-roles-types"],
        // uses a default export type and has been in other SEIMS modules and therefore named export was used for this fucntion
        queryFn: () => service.getParticipantTypes(),
        onError: (error) => recordError(error),
      },
      {
        queryKey: ["employment-status"],
        queryFn: () => service.getEmploymentStatus(),
        onError: (error) => recordError(error),
      },
    ],
  });

  return {
    qualifications: results[0],
    occupations: results[1],
    employmentSectors: results[2],
    participantRoles: results[3],
    employmentStatus: results[4],
  };
};